module.exports = __webpack_public_path__ + "static/media/heroku.03eb3e6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/heroku.png
// module id = 113
// module chunks = 0